import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { IconPlayInACircle } from '@redteclab/icons'

import { Dialog, DialogContent, DialogTitle, Link, Notification } from 'base-ui'

import { useCdnMediaServer } from '../../../cdn'
import { useOpenableControls } from '../../../generic-hooks'
import poster from '../../images/video-title-screen.jpg'
import { productAccessorIsPrescriptionProduct } from '../../model/productAccessor/productAccessorIsPrescriptionProduct'
import { useProductPageContext } from '../productPageContext'

import { PRESCRIPTION_PROCESS_VIDEO_SRC } from './prescriptionProcessVideoSrc'

export const ProductPrescriptionNotificationVideo: FC = () => {
  const { currentVariant } = useProductPageContext()
  const isPrescriptionProduct =
    productAccessorIsPrescriptionProduct(currentVariant)
  const modalControls = useOpenableControls()
  const { setMediaServerOrigin } = useCdnMediaServer()

  if (!isPrescriptionProduct) {
    return null
  }

  return (
    <>
      <Notification icon={<IconPlayInACircle />}>
        <p className="font-medium text-dark-primary-max">
          <FormattedMessage id="productAdditonalInfos.prescription.videobox.headline" />
        </p>
        <FormattedMessage id="productAdditonalInfos.prescription.videobox.content" />
        <div className="flex self-center tablet:self-start">
          <Link
            className="mt-4"
            color="inherit"
            onClick={modalControls.handleOpen}
          >
            <FormattedMessage id="productAdditonalInfos.prescription.videobox.links" />
          </Link>
        </div>
      </Notification>
      <Dialog onClose={modalControls.handleClose} open={modalControls.isOpen}>
        <DialogTitle onClose={modalControls.handleClose}>
          <FormattedMessage id="productAdditonalInfos.prescription.videobox.modal.headline" />
        </DialogTitle>
        <DialogContent className="flex flex-col">
          <video
            autoPlay
            className="h-auto w-full cursor-pointer"
            controls
            poster={poster.src}
            preload="none"
          >
            <source
              src={setMediaServerOrigin(PRESCRIPTION_PROCESS_VIDEO_SRC.MP4)}
              type="video/mp4"
            />
            <source
              src={setMediaServerOrigin(PRESCRIPTION_PROCESS_VIDEO_SRC.WEBM)}
              type="video/webm"
            />
          </video>
        </DialogContent>
      </Dialog>
    </>
  )
}
